/**
 * @param form {HTMLFormElement}
 * @return {string | undefined}
 */
module.exports = function getMarketoIdFromForm(form) {
    const formidInput = form.querySelector('[name="formid"]');

    if (formidInput instanceof HTMLInputElement) {
        return formidInput.value;
    }
}